
/* ==========================================
   CHHAYA DURGA PUJA POPUP
   File: assets/chhaya-pujo-popup.js
   ========================================== */

(function () {
  "use strict";

  function initChhayaPujoPopup() {
    var popup = document.getElementById("ChhayaPujoPopup");

    if (!popup || popup.dataset.initialized === "true") {
      return;
    }

    popup.dataset.initialized = "true";

    var dialog = popup.querySelector(".chhaya-pujo__dialog");
    var closeButtons = popup.querySelectorAll("[data-pujo-close]");
    var campaignId = popup.dataset.campaignId || "chhaya-pujo";
    var storageKey = "chhaya-pujo-dismissed-" + campaignId;

    var previousFocus = null;
    var isOpen = false;

    // Dismiss popup for 15 minutes.
    var DISMISS_DURATION = 15 * 60 * 1000;

    /* Parse YYYY-MM-DD as a local calendar date. */
    function parseLocalDate(value) {
      if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) {
        return null;
      }

      var parts = value.split("-").map(Number);
      var date = new Date(parts[0], parts[1] - 1, parts[2]);

      if (
        date.getFullYear() !== parts[0] ||
        date.getMonth() !== parts[1] - 1 ||
        date.getDate() !== parts[2]
      ) {
        return null;
      }

      date.setHours(0, 0, 0, 0);
      return date;
    }

    /* Check whether the campaign is active. */
    function isCampaignActive() {
      var today = new Date();
      today.setHours(0, 0, 0, 0);

      var startDate = parseLocalDate(popup.dataset.startDate);
      var endDate = parseLocalDate(popup.dataset.endDate);

      if (popup.dataset.startDate && !startDate) {
        console.warn("Chhaya Pujo popup: invalid start date.");
        return false;
      }

      if (popup.dataset.endDate && !endDate) {
        console.warn("Chhaya Pujo popup: invalid end date.");
        return false;
      }

      if (startDate && today < startDate) {
        return false;
      }

      if (endDate && today > endDate) {
        return false;
      }

      return true;
    }

    /* Display the optional order resumption date. */
    function formatResumptionDate() {
      var dateValue = popup.dataset.delayDate;
      var date = parseLocalDate(dateValue);

      var resumption = popup.querySelector(
        ".chhaya-pujo__resumption"
      );

      if (!date || !resumption) {
        return;
      }

      var englishDate = popup.querySelector("[data-pujo-date-en]");
      var bengaliDate = popup.querySelector("[data-pujo-date-bn]");

      if (englishDate) {
        englishDate.textContent = new Intl.DateTimeFormat("en-IN", {
          day: "numeric",
          month: "long",
          year: "numeric"
        }).format(date);
      }

      if (bengaliDate) {
        bengaliDate.textContent = new Intl.DateTimeFormat("bn-BD", {
          day: "numeric",
          month: "long",
          year: "numeric"
        }).format(date);
      }

      resumption.hidden = false;
    }

    /*
     * Return true when the popup was dismissed
     * less than 15 minutes ago.
     */
    function wasDismissed() {
      try {
        var savedValue = window.localStorage.getItem(storageKey);

        if (savedValue === null) {
          return false;
        }

        var dismissedAt = Number(savedValue);

        // Handle an old or invalid saved value safely.
        if (!Number.isFinite(dismissedAt) || dismissedAt <= 0) {
          window.localStorage.removeItem(storageKey);
          return false;
        }

        var elapsed = Date.now() - dismissedAt;

        // Expire the dismissal after 15 minutes.
        if (elapsed >= DISMISS_DURATION || elapsed < 0) {
          window.localStorage.removeItem(storageKey);
          return false;
        }

        return true;
      } catch (error) {
        console.warn(
          "Chhaya Pujo popup: unable to read dismissal storage.",
          error
        );

        return false;
      }
    }

    /*
     * IMPORTANT:
     * Save the current timestamp, NOT the string "true".
     * Keep only this one saveDismissal() function.
     */
    function saveDismissal() {
      try {
        window.localStorage.setItem(
          storageKey,
          String(Date.now())
        );
      } catch (error) {
        console.warn(
          "Chhaya Pujo popup: unable to save dismissal.",
          error
        );
      }
    }

    /* Open the popup. */
    function openPopup() {
      if (isOpen) {
        return;
      }

      previousFocus = document.activeElement;
      isOpen = true;

      popup.classList.add("is-visible");
      popup.setAttribute("aria-hidden", "false");
      document.body.classList.add("chhaya-pujo-open");

      var closeButton = popup.querySelector(".chhaya-pujo__close");

      if (closeButton) {
        closeButton.focus();
      } else if (dialog) {
        dialog.focus();
      }
    }

    /* Close the popup and save its dismissal time. */
    function closePopup() {
      if (!isOpen) {
        return;
      }

      isOpen = false;

      popup.classList.remove("is-visible");
      popup.setAttribute("aria-hidden", "true");
      document.body.classList.remove("chhaya-pujo-open");

      // Save the dismissal timestamp exactly once.
      saveDismissal();

      if (
        previousFocus &&
        typeof previousFocus.focus === "function"
      ) {
        previousFocus.focus();
      }
    }

    /* Handle close button and overlay clicks. */
    closeButtons.forEach(function (button) {
      button.addEventListener("click", closePopup);
    });

    /* Handle Escape and keyboard focus. */
    document.addEventListener("keydown", function (event) {
      if (!isOpen) {
        return;
      }

      if (event.key === "Escape") {
        event.preventDefault();
        closePopup();
        return;
      }

      if (event.key === "Tab" && dialog) {
        var focusable = dialog.querySelectorAll(
          'a[href], button:not([disabled]), input:not([disabled]), ' +
          'select:not([disabled]), textarea:not([disabled]), ' +
          '[tabindex]:not([tabindex="-1"])'
        );

        var elements = Array.from(focusable).filter(function (element) {
          return element.getClientRects().length > 0;
        });

        if (!elements.length) {
          event.preventDefault();
          dialog.focus();
          return;
        }

        var first = elements[0];
        var last = elements[elements.length - 1];

        if (
          event.shiftKey &&
          document.activeElement === first
        ) {
          event.preventDefault();
          last.focus();
        } else if (
          !event.shiftKey &&
          document.activeElement === last
        ) {
          event.preventDefault();
          first.focus();
        }
      }
    });

    formatResumptionDate();

    // Do not show outside the campaign dates.
    if (!isCampaignActive()) {
      return;
    }

    // Do not show again until 15 minutes have elapsed.
    if (wasDismissed()) {
      return;
    }

    // Show after the page is ready.
    window.setTimeout(openPopup, 500);
  }

  if (document.readyState === "loading") {
    document.addEventListener(
      "DOMContentLoaded",
      initChhayaPujoPopup
    );
  } else {
    initChhayaPujoPopup();
  }
})();
